export default "__VITE_ASSET__PZxni7vc__"